const getDateFromIso = isoDate => {
	if (isoDate && typeof isoDate === 'string') {
		const dateTime = new Date(isoDate.slice(0, -1));
		return dateTime;
	}
	return null;
};

export default getDateFromIso;